import { IIconProps } from './constants';

interface IProps extends IIconProps {
  isInverted?: boolean;
  isGreen?: boolean;
  dataTestId?: string;
}

export const ProIcon = ({
  width = 24,
  height = 24,
  isInverted = false,
  isGreen = false,
  ariaLabel = '',
  ariaHidden = false,
  dataTestId = '',
}: IProps) => {
  return !isInverted ? (
    /* Default abyss icon */
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-labelledby={ariaLabel}
      aria-hidden={ariaHidden}
      data-testid={dataTestId}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM8.57125 16.7192L12 14.5617L15.4287 16.7192L14.4363 12.7916L17.5478 10.1974L13.5057 9.92751L12 6.16665L10.4943 9.92751L6.45217 10.1974L9.56366 12.7916L8.57125 16.7192Z"
        fill={isGreen ? '#00C795' : 'currentcolor'}
      />
    </svg>
  ) : (
    /* Normal star (inverted mode) */
    <svg
      width={width}
      height={height}
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-labelledby={ariaLabel}
      aria-hidden={ariaHidden}
      data-testid={dataTestId}
    >
      <path
        d="M6.99984 1.16667L8.80234 4.81834L12.8332 5.40751L9.9165 8.24834L10.6048 12.2617L6.99984 10.3658L3.39484 12.2617L4.08317 8.24834L1.1665 5.40751L5.19734 4.81834L6.99984 1.16667Z"
        fill={isGreen ? '#00C795' : 'currentcolor'}
        stroke="#00C795"
        strokeWidth="1.16667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
